import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import request from "../utils/Request";
import useFetch from "../hooks/useFetch";
import InfoCard from "../components/InfoCard";
import Loading from "../utils/Loading";

const HeroBanner = () => {
  const [data, loading] = useFetch(request.fetchTrending);
  const url = "https://image.tmdb.org/t/p/original/";

  return (
    <div className="bg-gray-900 pt-5">
      {loading && <Loading />}
      <div className="relative sm:sm:w-[90%] shadow-2xl border border-gray-800 rounded-md sm:ml-auto sm:mr-auto">
        <div className="absolute w-full h-32 bg-gradient-to-t from-gray-800 to-transparent bottom-0 z-20" />
        <Carousel
          autoPlay
          infiniteLoop
          showStatus={false}
          showIndicators={false}
          showThumbs={false}
          interval={5000}
        >
          {data?.map((movie, index) => (
            <div key={index} className="sm:h-[80vh] shadow-lg">
              <InfoCard
                image={`${url}${movie?.backdrop_path}`}
                title={movie.original_name || movie.title}
                genre={movie.media_type}
                overview={movie.overview}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default HeroBanner;
